export class ES {
    getTranslations() {
        return {
            btn_validate: 'Aceptar',
            btn_cancel: 'Cancelar',
            btn_close: 'Cerrar',
            btn_add: 'Agregar',
            btn_delete: 'Eliminar',
            msg_alert: 'Alerta',
            msg_success: 'Éxito',
            msg_confirm: 'Confirmar',
            msg_input: 'Entrada',
            datahub_pickup_indicator: 'Seleccionar indicadores',
            datahub_fields: 'Campos',
            config_menu_loading: 'Cargando menú...',
            editable_label_edit: 'Editar',
            editable_label_validate: 'Validar',
            please_wait: 'Espere...',
            combobox_placeholder: 'Seleccionar una opción',
            card_button_start: 'Iniciar',
            enter_credentials_to: 'Por favor, introduzca sus credenciales para acceder a ',
        };
    }
}
